import { render, staticRenderFns } from "./PunchItemTable.vue?vue&type=template&id=6b49bdca"
import script from "./PunchItemTable.vue?vue&type=script&lang=ts"
export * from "./PunchItemTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports